import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import ImageListBody from './ImageListBody';
import ImageListData from './ImageListData';

const Edit = (props) => {
  const { data, block, selected, pathname, intl } = props;

  return (
    <>
      <ImageListBody
        data={data}
        id={block}
        path={pathname}
        intl={intl}
        isEditMode
      />
      <SidebarPortal selected={selected}>
        <ImageListData key={block} {...props} data={data} block={block} />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default Edit;
